import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {extendAndNavigate} from "../routing-util";

export const ensureSkipLocationChange = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	return extendAndNavigate(state.url, {skipLocationChange: true});
};
